<script>
  // 获取根节点
  function getNormalBaseTemp(h, childrenNodes = []) {
    return h('a-row', {}, [
      h('a-col',{ class: 'base-info-wrap' }, childrenNodes)
    ])
  }

  // 处理结果，如果是数字就切开，不然就正常
  function dealResult(contents) {
    if(Array.isArray(contents)) {
      return contents.join('；')
    }
    return contents
  }

  // 处理子节点，根据配置，可能

  // 处理结果节点
  function handleNormalNode(h, { content, noTitle, isVHtml}) {
    const tempNode = []
    for (const key in content) {
      if (Object.hasOwnProperty.call(content, key)) {
        const element = content[key];
        tempNode.push( h('div', 
        { 
          class: 'base-info-item',
          domProps: { 
            innerHTML:  isVHtml ? element : undefined
           } 
        }, 
        !isVHtml  // 不是v-html节点才可以
        && [
          noTitle ? '' : h('span', { class: 'infos-title' }, `${key}：`),
          h('span', { class: 'infos-content' }, dealResult(element))
        ]))
      }
    }
    return tempNode
  }
  // 根据不同的组件处理不同的逻辑
  function handleDiffTypeDetail(h) {
    const { componentName } = this.props.instance
    let contentNodes = []
    switch (componentName) {
      case 'Infos':
        contentNodes = handleNormalNode.call(this, h, this.props.instance)
        break;
      default:
        break;
    }
    const parentNode = getNormalBaseTemp.call(this, h, contentNodes)
    return parentNode
  }

  export default {
    functional: true,
    name: 'Infos',
    render(h, _this) {
      const resultNode = handleDiffTypeDetail.call(_this, h)
      return resultNode
    }
  }
</script>